import { render, staticRenderFns } from "./FormPage1.vue?vue&type=template&id=47b29720&scoped=true&"
import script from "./FormPage1.vue?vue&type=script&lang=js&"
export * from "./FormPage1.vue?vue&type=script&lang=js&"
import style0 from "./FormPage1.vue?vue&type=style&index=0&id=47b29720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b29720",
  null
  
)

export default component.exports